import { ApolloClient } from 'apollo-boost';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { BASE_GRAPHQL_URL, BASE_SEARCH_GRAPHQL_URL } from 'constants/graphql';
import { logoutUrl } from 'constants/links';

const graphql = new HttpLink({ uri: BASE_GRAPHQL_URL });
const graphqlSearch = new HttpLink({ uri: BASE_SEARCH_GRAPHQL_URL });

const graphqlEndpoints = ApolloLink.split(
  (operation) => operation.getContext().serviceName === 'search',
  graphqlSearch,
  graphql
);

const link = ApolloLink.from([
  onError(({ networkError }) => {
    if (networkError && networkError.response?.status === 401) {
      window.location.replace(logoutUrl);
    }
  }),
  graphqlEndpoints,
]);
const cache = new InMemoryCache();

const client = new ApolloClient({ link, cache });

export default client;
